// src/lib/firebaseClient.js
import { initializeApp, getApps, getApp } from 'firebase/app'
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth'
import {
  getFirestore,
  serverTimestamp,
  Timestamp,
  increment,
  arrayUnion,
  arrayRemove,
  deleteField,
  connectFirestoreEmulator,
} from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

// --- Config from Vite envs ---
const config = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
}

// --- Initialize immediately (singleton-safe) ---
export const app = getApps().length ? getApp() : initializeApp(config)

// --- Auth (persist sessions; NO anonymous auto sign-in) ---
export const auth = getAuth(app)
setPersistence(auth, browserLocalPersistence).catch(() => {})

// --- Firestore & Storage ---
export const db = getFirestore(app)
export const storage = getStorage(app)

// --- Optional emulators (dev only) ---
if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') {
  try {
    const fsHost = import.meta.env.VITE_FIRESTORE_EMULATOR_HOST || 'localhost'
    const fsPort = Number(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT || 8080)
    connectFirestoreEmulator(db, fsHost, fsPort)

    const stHost = import.meta.env.VITE_STORAGE_EMULATOR_HOST || 'localhost'
    const stPort = Number(import.meta.env.VITE_STORAGE_EMULATOR_PORT || 9199)
    connectStorageEmulator(storage, stHost, stPort)
  } catch {
    // ignore in prod
  }
}

// --- Re-exports so `@/firebase` stays convenient ---
export { serverTimestamp, Timestamp, increment, arrayUnion, arrayRemove, deleteField }

// (Optional) quick access from DevTools
import * as FS from 'firebase/firestore'
if (typeof window !== 'undefined') {
  window._appFB = { app, auth, db, storage, serverTimestamp }
  window._fs = FS
}